const QueryOptions = {
  EQUAL: 0,
  NOT_EQUAL: 1,
  GREATER_THAN: 2,
  GREATER_THAN_EQUAL: 3,
  LESS_THAN: 4,
  LESS_THAN_EQUAL: 5,
  SUBSTRING: 6,
  ENDS_WITH: 7,
  STARTS_WITH: 8,
  RANGE: 9,
  STRING_EQUAL: 10,
  STRING_NOT_EQUAL: 11,
  SUBPROPERTY_EQUAL: 12,
  SUBPROPERTY_NOT_EQUAL: 13,
  SUBPROPERTY_SUBSTRING: 14,
  SUBPROPERTY_ENDS_WITH: 15,
  SUBPROPERTY_STARTS_WITH: 16,
  DATE_EQUAL: 17,
  DAY_EQUAL: 18,
  DATE_RANGE: 19,
  DATE_GREATER_THAN: 20,
  DATE_GREATER_THAN_EQUAL: 21,
  DATE_LESS_THAN: 22,
  DATE_LESS_THAN_EQUAL: 23,
  CONTAINS: 24,
  SUBPROPERTY_CONTAINS: 25,
  CUSTOM_FILTER: 100,
};

QueryOptions.list = [
  QueryOptions.EQUAL,
  QueryOptions.NOT_EQUAL,
  QueryOptions.GREATER_THAN,
  QueryOptions.GREATER_THAN_EQUAL,
  QueryOptions.LESS_THAN,
  QueryOptions.LESS_THAN_EQUAL,
  QueryOptions.SUBSTRING,
  QueryOptions.ENDS_WITH,
  QueryOptions.STARTS_WITH,
  QueryOptions.RANGE,
  QueryOptions.STRING_EQUAL,
  QueryOptions.STRING_NOT_EQUAL,
  QueryOptions.SUBPROPERTY_EQUAL,
  QueryOptions.SUBPROPERTY_NOT_EQUAL,
  QueryOptions.SUBPROPERTY_SUBSTRING,
  QueryOptions.SUBPROPERTY_ENDS_WITH,
  QueryOptions.SUBPROPERTY_STARTS_WITH,
  QueryOptions.DATE_EQUAL,
  QueryOptions.DAY_EQUAL,
  QueryOptions.DATE_RANGE,
  QueryOptions.DATE_GREATER_THAN,
  QueryOptions.DATE_GREATER_THAN_EQUAL,
  QueryOptions.DATE_LESS_THAN,
  QueryOptions.DATE_LESS_THAN_EQUAL,
  QueryOptions.CONTAINS,
  QueryOptions.SUBPROPERTY_CONTAINS,
  QueryOptions.CUSTOM_FILTER,
];

export default QueryOptions;
